import { SOURCE_PREFIX } from './Constants';

const constructSourceId = (location, suffix='') =>
{
    const path = (location?.pathname || 'unknown').replace(/^\/+|\/+$/g, '') || 'home';
    const resolvedSuffix = ( suffix.length ) ? `-${suffix}` : '';
    return `${SOURCE_PREFIX}${path}${ resolvedSuffix }`;
}

export default constructSourceId;